'use client';

import { useSearchParams } from 'next/navigation';

import { ReleaseNotesDialog } from './ReleaseNotesDialog';

export function EmbedAwareReleaseNotes() {
  const searchParams = useSearchParams();

  if (searchParams?.get('embed') === '1') return null;

  return <ReleaseNotesDialog />;
}
